import React, { useState, useContext, useRef } from "react"
import MenuItem from "@material-ui/core/MenuItem"
import api from "../../services/api"
import ConfirmationModal from "../ConfirmationModal"
import { Menu, Typography } from "@material-ui/core"
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext"
import toastError from "../../errors/toastError"
import useStyles from "./styles"
import { Pencil, CornerUpLeft, RotateCw, Trash2, CornerUpRight } from "lucide-react"
import ModalSeletorContato from "../ModalSeletorContato"
import { EditMessageContext } from "../../context/EditMessage/EditMessageContext"
import PropTypes from "prop-types"
import { useHandleSendMessage } from "../MessageInputCustom/hooks/useHandleSendMessage"
import useHandleEncaminharMensagem from "../MessageInputCustom/hooks/useHandleEncaminharMensagem"
import { toast } from "react-toastify"
import { canais } from "../../utils/canais"
import { AuthContext } from "../../context/Auth/AuthContext"

const MENSAGEM_VISUALIZACAO_UNICA = "ERR_VIEW_ONCE_MESSAGE"
const VINTE_MINUTOS = 20 * 60 * 1000
const DOIS_DIAS_MS = 2 * 24 * 60 * 60 * 1000

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl, ticket }) => {
  const { user } = useContext(AuthContext)
  const messageSentAt = new Date(message.createdAt)
  const now = new Date()
  const menosDeVinteMinutos = now - messageSentAt <= VINTE_MINUTOS
  const menosDeDoisDias = now - messageSentAt <= DOIS_DIAS_MS
  const lProtocoloInfo =
    message?.body === "_INFO_" || (!message?.body?.startsWith("_INFO_") && !message?.body?.endsWith("_INFO_"))

  const lArquivoPerdido = message?.body === "*_Não foi possível recuperar o arquivo de mídia_*."
  const lMensagemAudio = message.mediaType === "audio"

  const lEhConversaInterna = ticket?.canalTipoId === canais.interno
  const lUsuarioPertenceAConversaInterna = user?.id === ticket?.usuarioId || user?.id === ticket?.responsavelId

  const lPermiteEditarMensagemInterna =
    lEhConversaInterna &&
    lUsuarioPertenceAConversaInterna &&
    !lArquivoPerdido &&
    !lMensagemAudio &&
    message.usuarioId === user?.id &&
    menosDeVinteMinutos

  const lPermiteApagarMensagemInterna =
    lEhConversaInterna && lUsuarioPertenceAConversaInterna && message.usuarioId === user?.id && menosDeDoisDias

  const lPermiteEditar =
    message.fromMe &&
    !message.encaminhada &&
    menosDeVinteMinutos &&
    !message?.body?.includes("BEGIN:VCARD") &&
    message?.body !== MENSAGEM_VISUALIZACAO_UNICA &&
    !message?.body?.startsWith("data:image/png;base64") &&
    lProtocoloInfo &&
    !lArquivoPerdido &&
    !lMensagemAudio

  const lPermiteApagar = message.fromMe && menosDeDoisDias

  const { setReplyingMessage } = useContext(ReplyMessageContext)
  const editMessageContext = useContext(EditMessageContext)
  const setEditMessage = editMessageContext ? editMessageContext.setEditMessage : () => {}
  const [confirmationOpen, setConfirmationOpen] = useState(false)
  const [loadingResend, setLoadingResend] = useState(false)
  const [lEncaminharMensagemModalAberto, setlEncaminharMensagemModalAberto] = useState(false)
  const [mensagemEncaminhada, setmensagemEncaminhada] = useState(null)
  const [lEncaminhando, setLEncaminhando] = useState(false)
  const lSubmissaoEncaminharRef = useRef(false)
  const classes = useStyles()
  const hookSendMessage = useHandleSendMessage()

  const handleDeleteMessage = async () => {
    // Validação de segurança no cliente: impede chamadas de exclusão fora do prazo
    if (!menosDeDoisDias) {
      toast.error("A exclusão só é permitida até 2 dias após o envio.")
      return
    }

    try {
      await api.delete(`/messages/${message.id}`)
    } catch (err) {
      toastError(err)
    }
  }

  const hanldeReplyMessage = () => {
    setEditMessage(null)
    setReplyingMessage(message)
    handleClose()
  }

  function getMensagemEditavel(text) {
    const lines = text.split("\n")
    if (lines[0].match(/^\*[^*]+:\*$/)) {
      return lines.slice(1).join("\n").trim()
    }
    return text
  }

  function getAssinatura(text) {
    const lines = text.split("\n")
    if (lines[0].match(/^\*[^*]+:\*$/)) {
      return lines[0]
    }
    return ""
  }

  const handleEditMessage = () => {
    setReplyingMessage(null)
    setEditMessage({
      ...message,
      mensagemEditavel: getMensagemEditavel(message.body),
      assinatura: getAssinatura(message.body),
    })
    handleClose()
  }

  const handleOpenConfirmationModal = () => {
    setConfirmationOpen(true)
    handleClose()
  }

  const handleAbrirModalEncaminharMensagem = () => {
    setmensagemEncaminhada(message)
    setlEncaminharMensagemModalAberto(true)
    handleClose()
  }

  const handleFecharModalEncaminharMensagem = () => {
    setlEncaminharMensagemModalAberto(false)
    setmensagemEncaminhada(null)
  }

  const fnHandleEncaminharMensagem = useHandleEncaminharMensagem()

  const handleEncaminharMensagem = async (mensagem, contatos) => {
    if (lSubmissaoEncaminharRef.current) {
      return
    }
    lSubmissaoEncaminharRef.current = true
    setLEncaminhando(true)
    try {
      await fnHandleEncaminharMensagem({ oMensagem: mensagem, mContatos: contatos })
      toast.success("Mensagem encaminhada com sucesso!")
    } catch (err) {
      // já tratado no hook
    } finally {
      setLEncaminhando(false)
      lSubmissaoEncaminharRef.current = false
      handleFecharModalEncaminharMensagem()
    }
  }

  const handleResendMessage = async () => {
    setLoadingResend(true)

    try {
      // Prepare the message data for resending
      const currentMessage = message.body
      const currentMedias = message.mediaUrl
      const currentReplyingMessage = message.quotedMsg || null
      const ticketId = message.ticketId
      const tempMessage = message
      const nCanalTipoId = message.ticket?.canalTipoId

      await hookSendMessage(
        currentMessage,
        currentMedias,
        currentReplyingMessage,
        ticketId,
        tempMessage,
        null, // editMessage
        setLoadingResend,
        nCanalTipoId,
      )
    } catch (err) {
      // Error is already handled in the hook
    } finally {
      handleClose()
    }
  }

  return (
    <>
      <ConfirmationModal
        title="Apagar mensagem?"
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={handleDeleteMessage}
      >
        Esta ação não pode ser revertida
      </ConfirmationModal>

      {message.isTemp ? (
        <Menu
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          classes={{ paper: classes.menuActions }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={menuOpen}
          onClose={handleClose}
        >
          <div className={classes.menu}>
            <MenuItem className={classes.menuItem} onClick={handleResendMessage} disabled={loadingResend}>
              <RotateCw className={loadingResend ? classes.rotateIcon : ""} />
              <div className={classes.textMenuPerfil}>
                <Typography>{loadingResend ? "Enviando..." : "Tentar Novamente"}</Typography>
              </div>
            </MenuItem>
            <MenuItem className={classes.menuItem} onClick={handleOpenConfirmationModal}>
              <Trash2 className={classes.deleteButton} />
              <div className={classes.textMenuPerfil}>
                <Typography className={classes.deleteButton}>Eliminar</Typography>
              </div>
            </MenuItem>
          </div>
        </Menu>
      ) : message.fromMe || lPermiteEditar ? (
        <Menu
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          classes={{ paper: classes.menuActions }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={menuOpen}
          onClose={handleClose}
        >
          <div className={classes.menu}>
            <MenuItem className={classes.menuItem} onClick={hanldeReplyMessage}>
              <CornerUpLeft />
              <div className={classes.textMenuPerfil}>
                <Typography>Responder</Typography>
              </div>
            </MenuItem>
            {message?.body !== MENSAGEM_VISUALIZACAO_UNICA && (
              <MenuItem className={classes.menuItem} onClick={handleAbrirModalEncaminharMensagem}>
                <CornerUpRight />
                <div className={classes.textMenuPerfil}>
                  <Typography>Encaminhar</Typography>
                </div>
              </MenuItem>
            )}
            {lPermiteEditar && (
              <MenuItem className={classes.menuItem} onClick={handleEditMessage}>
                <Pencil />
                <div className={classes.textMenuPerfil}>
                  <Typography>Editar</Typography>
                </div>
              </MenuItem>
            )}
            {lPermiteApagar && (
              <MenuItem className={classes.menuItem} onClick={handleOpenConfirmationModal}>
                <Trash2 className={classes.deleteButton} />
                <div className={classes.textMenuPerfil}>
                  <Typography className={classes.deleteButton}>Eliminar</Typography>
                </div>
              </MenuItem>
            )}
          </div>
        </Menu>
      ) : lEhConversaInterna ? (
        <Menu
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          classes={{ paper: classes.menuActions }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={menuOpen}
          onClose={handleClose}
        >
          <div className={classes.menu}>
            {lUsuarioPertenceAConversaInterna && (
              <MenuItem className={classes.menuItem} onClick={hanldeReplyMessage}>
                <CornerUpLeft />
                <div className={classes.textMenuPerfil}>
                  <Typography>Responder</Typography>
                </div>
              </MenuItem>
            )}
            {message?.body !== MENSAGEM_VISUALIZACAO_UNICA && (
              <MenuItem className={classes.menuItem} onClick={handleAbrirModalEncaminharMensagem}>
                <CornerUpRight />
                <div className={classes.textMenuPerfil}>
                  <Typography>Encaminhar</Typography>
                </div>
              </MenuItem>
            )}
            {lPermiteEditarMensagemInterna && (
              <MenuItem className={classes.menuItem} onClick={handleEditMessage}>
                <Pencil />
                <div className={classes.textMenuPerfil}>
                  <Typography>Editar</Typography>
                </div>
              </MenuItem>
            )}
            {lPermiteApagarMensagemInterna && (
              <MenuItem className={classes.menuItem} onClick={handleOpenConfirmationModal}>
                <Trash2 className={classes.deleteButton} />
                <div className={classes.textMenuPerfil}>
                  <Typography className={classes.deleteButton}>Eliminar</Typography>
                </div>
              </MenuItem>
            )}
          </div>
        </Menu>
      ) : (
        <Menu
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          classes={{ paper: classes.menuActions }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={menuOpen}
          onClose={handleClose}
        >
          <div className={classes.menu}>
            <MenuItem className={classes.menuItem} onClick={hanldeReplyMessage}>
              <CornerUpLeft />
              <div className={classes.textMenuPerfil}>
                <Typography>Responder</Typography>
              </div>
            </MenuItem>
            {message?.body !== MENSAGEM_VISUALIZACAO_UNICA && (
              <MenuItem className={classes.menuItem} onClick={handleAbrirModalEncaminharMensagem}>
                <CornerUpRight />
                <div className={classes.textMenuPerfil}>
                  <Typography>Encaminhar</Typography>
                </div>
              </MenuItem>
            )}
          </div>
        </Menu>
      )}
      {lEncaminharMensagemModalAberto && (
        <ModalSeletorContato
          lAberto={lEncaminharMensagemModalAberto}
          fnAoFechar={handleFecharModalEncaminharMensagem}
          fnAoConfirmar={(contatos) => handleEncaminharMensagem(mensagemEncaminhada, contatos)}
          lConfirmando={lEncaminhando}
        />
      )}
    </>
  )
}

MessageOptionsMenu.propTypes = {
  message: PropTypes.object.isRequired,
  menuOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.any,
}

export default MessageOptionsMenu
